import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/date-blue.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2f583268"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "feedingForm"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "flex align-center justify-between"
};
var _hoisted_4 = {
  class: "time-tag-wrap flex align-center"
};
var _hoisted_5 = {
  key: 0,
  class: "handover-text"
};
var _hoisted_6 = {
  key: 1,
  class: "power-on dateSelect flex align-center mt-1"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "date-blue"
  }, null, -1);
});
var _hoisted_8 = {
  class: "custom-action"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_tab = _resolveComponent("van-tab");
  var _component_van_tabs = _resolveComponent("van-tabs");
  var _component_van_icon = _resolveComponent("van-icon");
  var _component_van_notice_bar = _resolveComponent("van-notice-bar");
  var _component_van_popover = _resolveComponent("van-popover");
  var _component_c_type_tab = _resolveComponent("c-type-tab");
  var _component_date_header_with_btn = _resolveComponent("date-header-with-btn");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_tabs, {
    active: _ctx.tabIndexF,
    "onUpdate:active": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.tabIndexF = $event;
    }),
    background: "transparent",
    onChange: _ctx.confirmTypeF
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_tab, {
        title: "图表版",
        name: 0
      }), _createVNode(_component_van_tab, {
        title: "表格版",
        name: 1
      })];
    }),
    _: 1
  }, 8, ["active", "onChange"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(["time-tag", {
      'time-tag-active': _ctx.tabIndexS == 0
    }]),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.confirmTypeS(0);
    })
  }, " 交接班 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["time-tag", {
      'time-tag-active': _ctx.tabIndexS == 1
    }]),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.confirmTypeS(1);
    })
  }, " 开关机 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["time-tag", {
      'time-tag-active': _ctx.tabIndexS == 2
    }]),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.confirmTypeS(2);
    })
  }, " 自然日 ", 2)])]), _ctx.tabIndexS == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.handoverTime), 1)) : _createCommentVNode("", true), _ctx.tabIndexS == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
    class: "left",
    style: {
      backgroundColor: '#ffffff'
    },
    onClick: _cache[4] || (_cache[4] =
    //@ts-ignore
    function () {
      return _ctx.preClickPowerOn && _ctx.preClickPowerOn.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    size: "18",
    color: '#4372f6'
  })]), _createVNode(_component_van_popover, {
    show: _ctx.showPowerOnPopover,
    "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
      return _ctx.showPowerOnPopover = $event;
    }),
    actions: _ctx.powerOnActions,
    onSelect: _ctx.handlePowerOnSelect
  }, {
    reference: _withCtx(function () {
      return [_createVNode(_component_van_notice_bar, {
        class: "content",
        color: "#2c3e50",
        background: "#ffffff"
      }, {
        "left-icon": _withCtx(function () {
          return [_hoisted_7];
        }),
        default: _withCtx(function () {
          return [_createTextVNode(" " + _toDisplayString(_ctx.powerOnTime), 1)];
        }),
        _: 1
      })];
    }),
    action: _withCtx(function (_ref) {
      var action = _ref.action;
      return [_createElementVNode("div", _hoisted_8, _toDisplayString(action.showTime), 1)];
    }),
    _: 1
  }, 8, ["show", "actions", "onSelect"]), _createElementVNode("div", {
    class: "right",
    style: {
      backgroundColor: '#ffffff'
    },
    onClick: _cache[6] || (_cache[6] =
    //@ts-ignore
    function () {
      return _ctx.nextClickPowerOn && _ctx.nextClickPowerOn.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_van_icon, {
    name: "arrow",
    size: "18",
    color: '#4372f6'
  })])])) : _createCommentVNode("", true), _ctx.tabIndexS == 2 ? (_openBlock(), _createBlock(_component_c_type_tab, {
    key: 2,
    class: "mt-1",
    typeTabs: ['日', '周', '月', '自定义'],
    onConfirmType: _ctx.confirmTypeT
  }, null, 8, ["onConfirmType"])) : _createCommentVNode("", true), _ctx.tabIndexS == 2 ? (_openBlock(), _createBlock(_component_date_header_with_btn, {
    key: 3,
    ref: "dateRef",
    type: _ctx.params.type,
    showBtn: false,
    onConfirmDate: _ctx.confrimDate
  }, null, 8, ["type", "onConfirmDate"])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "feeding-text mt-1",
    onClick: _cache[7] || (_cache[7] =
    //@ts-ignore
    function () {
      return _ctx.toFeedingData && _ctx.toFeedingData.apply(_ctx, arguments);
    })
  }, "查看进料记录>"), _ctx.isShowComponent ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.curTabComponent), {
    key: 4,
    startTime: _ctx.params.startTime,
    endTime: _ctx.params.endTime,
    type: _ctx.params.type
  }, null, 8, ["startTime", "endTime", "type"])) : _createCommentVNode("", true)])]);
}